import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/operationtrend/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/operationtrend/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientTendaysdata = (params, urlParams) => {
  return axios.request({
    url: '/da/operationtrend/getclienttendaysdata' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

